export const reviewerType = {
  SEEKER: "SEEKER",
  SOLVER: "SOLVER",
};

export const reviewedObjectType = {
  CHALLENGE: "CHALLENGE",
  SOLUTION: "SOLUTION",
};
